<div class="projects-by-lpa">
  <!-- Widget Description -->
  <div class="widget-description mb-3">
    Displays all incomplete projects assigned to an LPC.
  </div>

  <!-- Filters Row (Horizontal) -->
  @if (isFilterVisible) {
    <div class="filters-row">
      <div class="horizontal-filters-container">
        <!-- Project Type Filter -->
        <div class="filter-item">
          <label>Project Type</label>
          <ng-select
            [items]="projectTypeOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Select project type"
            [(ngModel)]="selectedProjectType"
            (change)="onProjectTypeChange($event)"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Apply and Clear Filters -->
        <div class="filter-actions">
          <button class="btn btn-primary apply-btn" (click)="applyAllFilters()">Apply</button>
          <button class="btn btn-outline-secondary clear-btn" (click)="clearAllFilters()">
            <i class="bx bx-x-circle"></i> Clear
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Chart Row -->
  <div class="row">
    <!-- Chart Column (Full Width) -->
    <div class="col-12 chart-column">
      <div #chartContainer class="chart-container">
        @if (isLoading) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
          </div>
        }
        @if (!isLoading && chartData.length > 0) {
          <div class="chart-wrapper">
            <ngx-charts-bar-horizontal-stacked
              [view]="view"
              [scheme]="colorScheme"
              [customColors]="customColors"
              [results]="chartData"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legend]="showLegend"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel"
              [animations]="animations"
              [legendPosition]="legendPosition"
              [xAxisTickFormatting]="xAxisTickFormatting"
              (select)="onSelect($event)">
            </ngx-charts-bar-horizontal-stacked>
          </div>
        }
        @if (!isLoading && chartData.length === 0) {
          <div class="no-data-message">
            No project data available for the selected filters.
          </div>
        }
      </div>
    </div>
  </div>
</div>
